import React from 'react';

import { Box } from '@nerdwallet/currency';
import { TaxAnnouncementBanner as BainTaxAnnouncementBanner } from '@nerdwallet/bain-components';

import styles from './tax-announcement-banner.module.less';

interface TaxAnnouncementBannerProps {
  onCloseButtonClick?: () => void;
  onLinkClick?: () => void;
}

const TaxAnnouncementBanner: React.FC<TaxAnnouncementBannerProps> = ({
  onCloseButtonClick,
  onLinkClick,
}) => {
  // These are required by the BAIN Tax Announcement Banner, but we're passing placeholder values here because
  // we're disabling the built-in analytics in the component in favor of using the ones built here locally
  const placeholderSegmentAttributes = {
    pageViewId: '',
    pageViewReady: false,
  };

  return (
    <Box className={styles.bannerContainer}>
      <BainTaxAnnouncementBanner
        disableDefaultAnalytics
        onCloseButtonClickOverride={onCloseButtonClick}
        onLinkClickOverride={onLinkClick}
        segmentAttributes={placeholderSegmentAttributes}
      />
    </Box>
  );
};

export default TaxAnnouncementBanner;
